import cx from "classnames";
import React from "react";

import { UserChip } from "@/mk2/apps/forum/components/UserChip";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { Role, UserEntity } from "@/mk2/schemas";
import { DELETE_MODERATOR } from "@/mk/autogenerated/translation";

import styles from "./ModeratorListItem.mscss";

interface OwnProps {
    className?: string;
    user: UserEntity;
    canRemove: boolean;
    id: any;
    removing?: boolean;
    viewerRole?: Role;

    onRemove(id: any);
}

type Props = OwnProps;

export class ModeratorListItem extends React.PureComponent<Props> {
    public static defaultProps: Partial<Props> = {
        removing: false,
        viewerRole: Role.MODERATOR,
    };

    public render() {
        const { className, user, canRemove, removing, viewerRole } = this.props;

        return (
            <div className={cx(styles.ModeratorListItem, className)}>
                <div className={styles.ModeratorListItem__left}>
                    <UserChip user={user} size={40} />
                </div>
                <div className={styles.ModeratorListItem__right}>
                    {canRemove && (
                        <Btn
                            type={
                                viewerRole === Role.MODERATOR
                                    ? BtnType.ModeratorOutline
                                    : BtnType.AdminOutline
                            }
                            label={DELETE_MODERATOR}
                            onClick={this.onRemove}
                            disabled={removing}
                            hasSpinner={removing}
                        />
                    )}
                </div>
            </div>
        );
    }

    private onRemove = () => {
        this.props.onRemove(this.props.id);
    };
}
